export default "/images/ed7d41294ac176d80761428c5087b3dd.avif";